import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

type Crumb = {
  label: string;
  onBreadcrumbClick?: () => void;
};
type Props = {
  paths: Crumb[];
  onTrim?: (index: number) => void;
};

export default function CustomBreadcrumbs({ paths, onTrim }: Props) {
  const handleClick = (
    e: React.MouseEvent,
    onBreadcrumbClick: (() => void) | undefined,
    index: number
  ) => {
    e.preventDefault();
    if (onBreadcrumbClick) onBreadcrumbClick();
    if (onTrim) onTrim(index);
  };

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
      {paths.map((crumb, index) => {
        const isLast = index === paths.length - 1;

        return isLast ? (
          <Typography color="text.primary" key={crumb.label}>
            {crumb.label}
          </Typography>
        ) : (
          <Link
            key={crumb.label}
            underline="hover"
            color="inherit"
            href="#"
            onClick={(e) => handleClick(e, crumb.onBreadcrumbClick, index)}
          >
            {crumb.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
